import React, { RefObject } from 'react';
import images from '../assets/images';
import { CInputPropTypes } from '../typedef/cinput.types';
import '../styles/coutline.input.styles.css';

const COutlineInput = ({
  inputId,
  input,
  setInput,
  type,
  label,
  error: { onError, errorMessage },
  inputRef,
  icon,
  onFocused,
  onBlured,
  onDeleteInputClicked = () => {},
  disabled = false,
  isRequired,
  placeholder,
}: CInputPropTypes & { icon?: string }) => {
  return (
    <div className='coutline-root'>
      <label htmlFor={inputId}>
        <span className='coutline-label'>
          {label}
          {isRequired && <span className='coutline-input-required'>*</span>}
        </span>
      </label>
      <div className='coutline-input'>
        {disabled ? (
          <div className='coutline-disabled-input'>{input}</div>
        ) : (
          <>
            {icon && (
              <img
                className='coutline-input-icon'
                src={icon}
                alt='input icon'
              />
            )}
            <input
              style={{
                paddingLeft: icon ? '44px' : '12px',
              }}
              id={inputId}
              onFocus={onFocused}
              onBlur={onBlured}
              className='coutline-input-input'
              ref={inputRef}
              type={type}
              onChange={(e) => setInput(e.target.value)}
              placeholder={placeholder}
            />
            {input !== '' && (
              <button
                className='coutline-delete-btn'
                onClick={onDeleteInputClicked}>
                <img
                  src={images.deleteBtn}
                  alt={`delete input btn of ${inputId}`}
                />
              </button>
            )}
          </>
        )}
      </div>
      {!disabled && onError && (
        <div className='coutline-error-message'>{errorMessage}</div>
      )}
    </div>
  );
};

export default COutlineInput;
